import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { Product } from '../types/product.type';

export type ArchiveProductPayload = {
  product_id: string;
};
export type ArchiveProductResponse = ApiResponse<Product>;

export const archiveProduct = async (
  payload: ArchiveProductPayload
): Promise<ArchiveProductResponse> => {
  const { product_id } = payload;
  const url = `product/${product_id}/archive`;

  return await apiClient.patch(url);
};

export function archiveProductMutationOptions() {
  return mutationOptions<
    ArchiveProductResponse,
    AxiosError,
    ArchiveProductPayload
  >({
    mutationFn: archiveProduct,
  });
}
